module.exports = function () {
    $(document).on('click', 'a[data-personalization-rule-name]', function () {
        try {
            var ruleName = $(this).data('personalizationRuleName');
            var moduleType = $(this).data('personalizationModuleType');

            var targetUrl = $(this).attr('href');

            if (targetUrl.indexOf('#') !== 0 && targetUrl.indexOf('http') === -1) {
                targetUrl = window.location.protocol + '//' + window.location.hostname + targetUrl;
            }

            dataLayer.push({
                event: 'Personalized Click',
                moduleType: moduleType,
                pageUrl: window.location.href,
                targetUrl: targetUrl,
                personalizationRuleName: ruleName
            });
        }
        catch (e) {
            console.error('Failed to send personalization error to datalayer: ' + e.message);
        }
    });
};